import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {FciErrorType} from '@core/api/fci-error-type';
import {HttpService} from '@app/services/http.service';

@Injectable({providedIn: 'root'})
export class UtilsApiService {
	constructor(
		private http: HttpService
	) {
	}

	/**
	 * Log Page View
	 * @param {string} url
	 * @returns {Observable<void>}
	 */
	public logPageView(url: string): Observable<void> {
		return this.http.post('/stories/api/util/log-page-view', {path: url}, FciErrorType.convenience);
	}
}
